module.exports = __webpack_public_path__ + "static/media/BOG-5.08ec1ce3.pdf";